// Collapsible "AI Insights" banner — for single-view module pages that
// don't have tabs. Renders a header strip you can toggle to expand the
// reusable ModuleInsightsDashboard.
import { useState } from 'react';
import { Sparkles, ChevronDown, ChevronRight } from 'lucide-react';
import ModuleInsightsDashboard from '@/components/common/ModuleInsightsDashboard';

export default function ModuleInsightsPanel({ projectId, moduleKey, color = '#143A6B',
                                              deepLinkBase = '', defaultOpen = false, title = 'AI Insights · Risks · Actions' }) {
  const [open, setOpen] = useState(defaultOpen);
  if (!projectId) return null;
  return (
    <section className="rounded-lg overflow-hidden"
      style={{ background: 'var(--card-bg)', border: `1px solid ${color}30` }}
      data-testid={`module-insights-panel-${moduleKey}`}>
      <button onClick={() => setOpen(o => !o)}
        data-testid={`module-insights-panel-toggle-${moduleKey}`}
        className="w-full flex items-center justify-between px-4 py-2.5 text-left"
        style={{ background: `${color}10` }}>
        <span className="flex items-center gap-2 text-sm font-semibold" style={{ color }}>
          <Sparkles className="w-4 h-4" /> {title}
        </span>
        {open ? <ChevronDown className="w-4 h-4" style={{ color }} /> : <ChevronRight className="w-4 h-4" style={{ color }} />}
      </button>
      {open && (
        <div className="p-4">
          <ModuleInsightsDashboard projectId={projectId} moduleKey={moduleKey} color={color}
            deepLinkBase={deepLinkBase} embedded showHelp={false} />
        </div>
      )}
    </section>
  );
}
